import React, { Component } from "react";
import raf from "raf";
import { Header } from "./Header";
import "./HeaderContainer.css";

export class HeaderContainer extends Component {
  constructor() {
    super();
    this.state = {
      pinned: false
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    let pinned = false;
    if (typeof window !== "undefined") {
      pinned = window.pageYOffset > 0;
    }
    this.setState({
      pinned
    });
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    raf.cancel(this.raf);
    this.raf = raf(() => {
      const pinned = window.pageYOffset > 0;
      if (this.state.pinned !== pinned) {
        this.setState({ pinned });
      }
    });
  }

  render() {
    const { pinned } = this.state;
    return (
      <div className="containerHeader">
        <Header pinned={pinned} {...this.props} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HeaderContainer.js